import { openDB } from 'idb';
import { StepUpSIP } from '../models/stepup-sip';

const dbPromise = openDB('stepup-sip-db', 1, {
  upgrade(db) {
    db.createObjectStore('stepup-sip', { keyPath: 'id', autoIncrement: true });
  },
});

export const saveStepUpSIP = async ({
  monthlyDeposit,
  stepUpPercent,
  interestRate,
  timePeriod,
  totalPrincipal,
  estimatedReturns,
  totalAmount,
  currencySymbol,
  title,
}: StepUpSIP): Promise<void> => {
  const db = await dbPromise;
  await db.add('stepup-sip', {
    monthlyDeposit,
    stepUpPercent,
    interestRate,
    timePeriod,
    totalPrincipal,
    estimatedReturns,
    totalAmount,
    currencySymbol,
    title,
  });
};

export const fetchStepUpSIPs = async (): Promise<StepUpSIP[]> => {
  const db = await dbPromise;
  const allSIPs: StepUpSIP[] = await db.getAll('stepup-sip');
  return allSIPs;
};

export const updateStepUpSIP = async (
  id: number,
  updatedData: Omit<StepUpSIP, 'id'>
): Promise<void> => {
  const db = await dbPromise;
  await db.put('stepup-sip', { id, ...updatedData });
};

export const deleteStepUpSIP = async (id: number): Promise<void> => {
  const db = await dbPromise;
  await db.delete('stepup-sip', id);
};
